import { render } from "./AlbumUpload.vue?vue&type=template&id=4cba85ad&scoped=true"
import script from "./AlbumUpload.vue?vue&type=script&lang=js"
export * from "./AlbumUpload.vue?vue&type=script&lang=js"

import "./AlbumUpload.vue?vue&type=style&index=0&id=4cba85ad&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao-up-up-mobile-spa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cba85ad"]])

export default __exports__